// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "stock_order_fee".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { stockOrderFeeTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "stock_order_fee" table (1:1 with a DB row, on the wire). */
export const stockOrderFeeAtomSchema = z.object({
    id: z.string(),
    stockOrderId: z.string(),
    name: z.string(),
    type: z.enum(stockOrderFeeTypeValues),
    value: z.number(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=stockOrderFee.js.map